import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/")({
  staticData: {
    title: "fleets.title",
  },
  loader: ({ params }) =>
    redirect({
      to: "/sources/fleets/$id/general",
      params: { id: params.id },
      replace: true,
    }),
});
